import fullsizeImagesUI from './fullsize';
import currentYear from './current-year';
import adaUI from './ada';
import cookiesUI from './cookie';
import headerUI from './header';
import subscribeUI from './subscribe';
import personalizationUI from './modules/personalizationUI';
import initBookingMask from './BookingMask';
import portal from './portal';
import qtyUI from './qty';

import { $win } from './utils';

;(function(window, document, $) {
	initBookingMask();

	$('.js-move').each(function() {
		const $this = $(this);
		const $target = $($this.data('target'));

		$target.append($this);
	});

	// Offer buttons can trigger the booking mask (in specific case)
	$(document).on('click', '.js-booking-offer', function(e){
		const target = this.getAttribute('data-target');

		// Normal links should just open
		if (/^(mailto:|tel:|http|\/)/.test(target)) {
			window.open(target,'_blank');
			return;
		}

		$('.booking-mask').find('input[name="promoCode"]').val(target);
		openBMWithOverlay();
	});


	$('a[href^="tel"]').each(function() {
		const linkHref = $(this).attr('href');

		$(this).attr('href', linkHref.replace(/ /igm, ''));
	});

	$('.js-trim-decimals').each(function() {
		const number = Math.trunc($(this).text());

		$(this).text(number);
	});

	$('.js-add-commas').each(function() {
		const number = $(this).text();
		const length = number.length;

		if ( length > 3 ) {
			$(this).text(number.slice(0, length - 3) + ',' + number.slice(length - 3,length));
		}
	});

	$('.js-date').each(function() {
		const $this = $(this);
		const dateText = $this.data('date') ? $this.data('date') : $this.text();
		const date = moment(dateText);
		const format = $this.data('format');

		if ( date.isValid() ) {
			$this.html(date.format(format));
		} else {
			$this.remove();
		}
	});

	$('.actions-inline').each(function(index, el) {
		const $items = $(el).find('.action-inline');

		if ($items.length > 1) {
			$(el).addClass('plural')
		}
	});

	function openBMWithOverlay() {
		$('.booking-mask__body').slideDown();
		$('.booking-mask').addClass('active');
		$('.wrapper').addClass('overlay');

		// TODO -> add overlay
	}


	$('.js-select-tab select').on('change', function () {
		$(this.value).addClass('show active').siblings().removeClass('show active');
	});

	$('.js-scroll-to-top').on('click', function(event) {
		event.preventDefault();

		$('html, body').animate({
			scrollTop: 0
		});
	});

	fullsizeImagesUI();

	if ($('.js-slider').length) {
		import(/* webpackChunkName: "sliders" */ './sliders.js').then(module => {
			module.default();
		});
	}

	if ($('.js-filter-container').length) {
		import(/* webpackChunkName: "filtersUI" */ './filtersUI.js').then(module => {
			module.default();
		});
	}

	if ($('.slider-gallery-main__slides').length) {
		import(/* webpackChunkName: "gallery" */ './gallery.js').then(module => {
			module.default();
		});
	}

	adaUI();

	// Add js-year-container class where you want to print the current year
	currentYear();

	if ($('[data-shave]').length) {
		import(/* webpackChunkName: "shave-ui" */ './shave-ui.js').then(module => {
			module.default();
		});
	}

	if ($('[data-read-more]').length) {
		import(/* webpackChunkName: "read-more-ui" */ './read-more-ui.js').then(module => {
			module.default();
		});
	}

	cookiesUI();

	if ($('.map').length) {
		import(/* webpackChunkName: "maps-ui" */ './maps-ui.js').then(module => {
			module.default();
		});
	}

	headerUI();

	subscribeUI();

	// there are select in the BM dropown for children
	import(/* webpackChunkName: "select" */ './select.js').then(module => {
		module.default();
	});

	if ($('.js-form').length) {
		import(/* webpackChunkName: "forms-ui" */ './forms-ui.js').then(module => {
			module.default();
		});
	}

	$win.on('load', function() {
		import(/* webpackChunkName: "booking" */ './booking.js').then(module => {
			module.default();
		});
	});

	if ($('.js-datepicker-single').length) {
		import(/* webpackChunkName: "single-picker" */ './single-picker.js').then(module => {
			module.default();
		});
	}

	if ($('.js-datepicker-forms').length) {
		import(/* webpackChunkName: "range-picker-forms" */ './range-picker-forms.js').then(module => {
			module.default();
		});
	}

	portal();
	
	personalizationUI();

	qtyUI();


	// Form Modal Import New Code (Broucher Ticket)
	if (document.querySelectorAll('[data-target="#modal-subscription"]').length) {
		import(/* webpackChunkName: "modal-ui" */ './modal').then(module => {
			module.default();
		});
	}

  if (document.querySelectorAll('[data-cms="block/intro-home"] .js-intro-home-has-video').length) {
		import(/* webpackChunkName: "intro-video" */ './intro-video')
      .then(module => {module.default()})
      .catch(error => console.error('Error loading intro-video module:', error))
	}

})(window, document, window.jQuery);
